import api from './client';

export interface AuditLogEntry {
  id: number;
  user_id: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  details: Record<string, unknown> | null;
  ip_address: string | null;
  created_at: string;
}

export async function listAuditLogs(params?: {
  resource_type?: string;
  resource_id?: string;
  limit?: number;
  offset?: number;
}) {
  const res = await api.get<AuditLogEntry[]>('/audit-logs', { params });
  return res.data;
}
